<template>
  <div class="factoryFireControl-page">
    <!-- 厂区消防 -->
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="caseDetails-banner-container">
      <div class="case-info-container">
        <p class="case-title">厂区消防</p>
        <p class="case-describe">工业园区安环管控一体化，园区安环一体化综合管控系统</p>
        <!-- <a href="javascript:;" class="case-see-more-btn">点击咨询</a> -->
      </div>
    </div>
    <div class="caseDetails-all-content-container">
      <div class="case-introduce-item-container case-introduction">
        <div class="caseDetails-center-content-container">
          <div class="introduce-content-container">
            <img src="../../assets/img/caseDetails/factoryFireControl/default_img9.png" alt="" class="case-introduction-img">
            <div class="text-description-container">
              <p class="first-title">案例介绍</p>
              <p class="sub-title"></p>
              <p class="other-description">工业园区安环管控一体化，园区安环一体化综合管控系统对园区电力监测、烟雾、可燃气体、大气污染监测、空气质量监测、视频数据、入侵数据等进行实时在线监测、告警，监测数据接入值班室电脑和移动终端，一旦监测数据出现异常，系统会立即报警，提醒工作人员及时采取补救措施，把事故损失降到最低。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="case-introduce-item-container interface">
        <div class="caseDetails-center-content-container">
          <div class="introduce-content-container">
            <div class="text-description-container">
              <p class="first-title">操作界面</p>
              <p class="sub-title"></p>
              <p class="other-description"></p>
            </div>
            <img src="../../assets/img/caseDetails/factoryFireControl/default_img10.png" alt="" class="interface-img">
          </div>
        </div>
      </div>
      <div class="case-introduce-item-container other-interface">
        <div class="caseDetails-center-content-container">
          <div class="introduce-content-container">
            <div class="text-description-container">
              <p class="first-title">机房环境监测</p>
              <p class="sub-title"></p>
              <p class="other-description"></p>
            </div>
            <img src="../../assets/img/caseDetails/factoryFireControl/default_img11.png" alt="" class="interface-img interface-img1">
            <img src="../../assets/img/caseDetails/factoryFireControl/default_img8.png" alt="" class="interface-img interface-img2">
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'

export default {
  name: 'factoryFireControl',
  components:{
    Header,
    Nav,
    Foot
  },
}
</script>
<style lang="scss">
  
</style>